export const HOME = "/";

export const LOGIN = "/login";
export const SIGNUP = "/signup";
export const PASSWORD_RESET = "/reset-password";

export const PROTECTED = "/u";
export const DEEP_LINK = "/d";

export const VOUCHERS = "/vouchers";
export const PROFILE = "/profile";
export const SETTINGS = "/settings";
export const SYSTEM = SETTINGS + "/system";
export const STUDENT_CARD = SETTINGS + "/student-card";
export const DASHBOARD = "/home";

export const ACCOUNTS = "/accounts";

export const MEALS = "/meals";
export const MEAL_BOOKINGS = MEALS + "/bookings";
export const MEAL_COLLECTIONS = MEALS + "/collections";

export const FEEDBACK_BASE = "/feedback";
export const FEEDBACK = FEEDBACK_BASE + "/feedback";
export const SURVEY = FEEDBACK_BASE + "/survey";

export const AUTH_ACTION = "/_/auth/action";
export const AUTH_PASSWORD_RESET = "/_/auth/password_reset";
